// DevToolsProtector.jsx
import React, { useEffect, useRef } from 'react';
import { runTimingCheck, runSizeCheck } from './DevToolsDetector'; 
import activityLogSubmission from '../helper/activitylog';

const LOCAL_STORAGE_KEY = 'devCheck';
const CHECK_INTERVAL = 500; // Check every 500ms
const TIMING_THRESHOLD = 200; // milliseconds (Time delay indicating debugger pause)

const DevToolsProtector = ({ children }) => {
    const intervalRef = useRef(null);
    const protectionTriggeredRef = useRef(false);

    /**
     * Executes the protection action: stopping checks and immediate redirection.
     */
    const handleProtectionAction = () => {
        if (protectionTriggeredRef.current) return;
        
        // 1. Stop the periodic check
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        console.warn("Multi-layer DevTools detection confirmed. Redirecting.");
        protectionTriggeredRef.current = true;

        // 2. Immediate Redirection to prevent inspection or interaction
        // Use replace() to prevent the back button from working easily
        activityLogSubmission("devtools-detected");
        window.location.replace('https://arcaderush.xyz');
        
        // Optional: Throw an error to stop any ongoing React cycles
        // throw new Error("Security Alert: DevTools Detection Triggered!");
    };

    useEffect(() => {
        // --- 1. Check Local Storage Bypass ---
        const devMode = localStorage.getItem(LOCAL_STORAGE_KEY);
        
        if (devMode === 'true') {
            console.log("DevTools protection bypassed via localStorage.");
            return;
        }

        // --- 2. Start Periodic Check ---
        const checkDevTools = () => {
            if (protectionTriggeredRef.current) return;
            
            // A. Timing Check (Detects debugger pause/slight delay)
            const timeElapsed = runTimingCheck();
            const isTimingCheckTrue = timeElapsed > TIMING_THRESHOLD;

            // B. Window Size Check (Detects docked panel)
            const isSizeCheckTrue = runSizeCheck();
            // The protection fires if *either* check confirms DevTools is open.
            if (isTimingCheckTrue) {
                // If DevTools is open (paused or docked), execute protection action
                handleProtectionAction();
            }
        };

        // Start checking periodically
        intervalRef.current = setInterval(checkDevTools, CHECK_INTERVAL);

        // --- 3. Cleanup Function ---
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };

    }, []); // Runs only once on component mount

    return <>{children}</>;
};

export default DevToolsProtector;